import { SECURE_RANDOM_NUMBER } from '../../services/common.service';

export class RouteState {
  constructor() {
    this.id = Math.floor(SECURE_RANDOM_NUMBER.value * 90000) + 10000;
  }
  id: number;
  path: string;
  data: any;
  title: string;
}
